import { motion } from "framer-motion";

export const SystemArchitectureDiagram = () => (
  <section
    id="architecture"
    data-testid="system-architecture-section"
    className="bg-baseLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]"
  >
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl lg:mx-auto lg:max-w-[840px] lg:text-center"
      >
        <h2
          data-testid="system-architecture-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:whitespace-nowrap lg:text-[36px]"
        >
          One system. Multiple energy pathways
        </h2>
        <p data-testid="system-architecture-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
          Solar and wind supply farm loads, supported by battery buffering and reversible
          hydrogen storage.<br className="hidden lg:block" /> The Energy Management System coordinates these pathways,<br className="hidden lg:block" />
          with the final configuration tailored to each site.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        data-testid="system-architecture-diagram"
        className="mt-10 flex justify-center lg:mt-[38px]"
      >
        <img
          src="/system-architecture-diagram.png"
          alt="System architecture diagram: solar and wind generation, energy management system, battery storage and hydrogen system supporting farm loads"
          className="w-full max-w-[1100px] h-auto"
        />
      </motion.div>
    </div>
  </section>
);
